import React, { useState, useEffect, Fragment } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box,
  Card,
  Grid,
  TextField,
  makeStyles,
  Container,
  CardContent,
  Divider,
  InputLabel,
  CardHeader,
  MenuItem,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Table,
  Hidden
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { useNavigate, useParams } from 'react-router-dom';
import { Formik } from 'formik';
import PageHeader from 'src/views/Common/PageHeader';
import { LoadingComponent } from '../../../utils/newLoader';
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../utils/permissionAuth';
import tokenDecoder from '../../../utils/tokenDecoder';
import tokenService from '../../../utils/tokenDecoder';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker } from '@material-ui/pickers';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CountUp from 'react-countup';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  }
}));

var screenCode = 'ACCOUNTPAYABLE';
export default function AccountPayableView() {
  const { referenceNumber } = useParams();
  const { invoiceDetailID } = useParams();
  const { groupID } = useParams();
  const { factoryID } = useParams();
  const navigate = useNavigate();
  const [title, setTitle] = useState('Account Payable');
  const classes = useStyles();
  const [factories, setFactories] = useState();
  const [groups, setGroups] = useState();
  const [journalData, setJournalData] = useState([]);
  const [accountTypeNames, setAccountTypeNames] = useState();
  const [accountDescriptionsType, setAccountDescriptionsType] = useState({});
  const [voucherTypes, setVoucherTypes] = useState([]);
  const [transactionModes, setTransactionModes] = useState([]);
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false
  });
  const [accountPayable, setAccountPayable] = useState({
    groupID: '0',
    factoryID: '0',
    transactionTypeID: '0',
    referenceNumber: '',
    payableReferenceNumber: '',
    description: '',
    desc: '',
    remark: '',
    payableDescription: '',
    descriptionTypeID: 0,
    payModeID: '0',
    chequeNumber: '',
    isActive: true,
    preparedBy: '',
    updatedBy: '',
    voucherType: '0',
    voucherCode: '',
    transactionMode: '0',
    recipientName: '',
    address: '',
    isInterEstate: false,
    interEstateID: '0',
    supplierID: '0',
    invoiceNo: '',
    tranLedgerAccountID: '0',
  });
  const [selectedTransactionDate, handleTransactionDateChange] = useState(new Date());
  const [selectedInvoicenDate, handleInvoiceDateChange] = useState(new Date())
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [suppliers, setSuppliers] = useState();
  const [isView, setIsView] = useState(false);
  const [refNo, setRefNo] = useState();
  const [isInterStatus, setIsInterStatus] = useState(false);
  const [tranLedgerList, setTranLedgerList] = useState([]);
  const [accountDescriptions, setAccountDescriptions] = useState({});
  const [status, setStatus] = useState(0);
  const handleClick = () => {
    navigate('/app/accountPayable/listing');
  }

  let decrypted = 0;
  let decryptedfactoryID = 0;
  let decryptedgroupID = 0;
  let decryptedVoucherCode = 0;

  useEffect(() => {
    trackPromise(getPermissions());
    trackPromise(getGroupsForDropdown());
  }, []);

  useEffect(() => {
    trackPromise(getfactoriesForDropDown());
  }, [accountPayable.groupID]);

  useEffect(() => {
    trackPromise(getVoucherTypeList());
    trackPromise(getTransactionModeList());
    trackPromise(getTranLedgerList());
  }, [accountPayable.factoryID]);

  useEffect(() => {
    decrypted = atob(invoiceDetailID.toString());
    decryptedVoucherCode = atob(referenceNumber.toString());
    decryptedgroupID = atob(groupID.toString());
    decryptedfactoryID = atob(factoryID.toString());
    if (decrypted != 0) {
      trackPromise(getAccountPayableDetails(decrypted, decryptedVoucherCode, decryptedgroupID, decryptedfactoryID))
    }
  }, []);

  useEffect(() => {
    if (accountPayable.transactionTypeID != 0) {
      trackPromise(getReferenceNumber());
    }
  }, [accountPayable.transactionTypeID]);

  useEffect(() => {
    if (accountPayable.factoryID.toString() !== '0') {
      trackPromise(getSuppliersForDropDown());
    }
  }, [accountPayable.factoryID]);

  useEffect(() => {
    const lastInvoiceNumber = localStorage.getItem('lastInvoiceNumber') || "REF0000";
    generateNextInvoiceNumber(lastInvoiceNumber);
  }, []);

  useEffect(() => {
    if (!isView) {
      setAccountPayable({
        ...accountPayable,
        transactionMode: '0',
      })
    }
  }, [accountPayable.factoryID]);

  useEffect(() => {
    if (!isView) {
      setAccountPayable({
        ...accountPayable,
        supplierID: '0',
      })
    }
  }, [accountPayable.transactionMode]);

  const generateNextInvoiceNumber = (lastInvoiceNumber) => {
    const numericPart = parseInt(lastInvoiceNumber.slice(3), 10) + 1;
    const newInvoiceNumber = `REF${numericPart.toString().padStart(4, '0')}`;
    setInvoiceNumber(newInvoiceNumber);
    localStorage.setItem('lastInvoiceNumber', newInvoiceNumber);
  };

  function generateDropDownMenuWithTwoValues(data) {
    let items = []
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(<MenuItem key={key} value={key}>{value.name}</MenuItem>);
      }
    }
    return items
  }

  async function getReferenceNumber() {
    if (accountPayable.referenceNumber < 1 || accountPayable.referenceNumber == "" || accountPayable.referenceNumber == undefined) {
      let refModel = {
        groupID: accountPayable.groupID,
        factoryID: accountPayable.factoryID,
        transactionTypeID: accountPayable.transactionTypeID,
        isActive: true,
      }
      const ref = await services.getReferenceNumber(refModel);
      setAccountPayable({ ...accountPayable, referenceNumber: ref });
      setRefNo(ref.data);
    }
  }

  async function getTranLedgerList() {
    const transaction = await services.getTranLedgerListForDropdown(accountPayable.factoryID);
    setTranLedgerList(transaction);
  }

  async function getSuppliersForDropDown() {
    const supplierResult = await services.getSuppliersForDropDown(
      accountPayable.factoryID
    );
    setSuppliers(supplierResult);
  }

  async function getAccountTypeNames(childHeaderModel) {
    const accounts = await services.getLedgerAccountNamesForDatagrid(childHeaderModel);
    setAccountTypeNames(accounts);
    return accounts;
  }

  async function getAccountDescriptionsNormal(accID) {
    const accountDescriptions = await services.getAccountDescriptionsNormal(accID);
    setAccountDescriptionsType(accountDescriptions);
  }

  async function getPermissions() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(
      p => p.permissionCode == 'ADDEDITACCOUNTPAYABLE'
    );

    if (isAuthorized === undefined) {
      navigate('/404');
    }
    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined
    });

    setAccountPayable({
      ...accountPayable,
      groupID: parseInt(tokenService.getGroupIDFromToken()),
      factoryID: parseInt(tokenService.getFactoryIDFromToken())
    });
  }

  async function getfactoriesForDropDown() {
    const factory = await services.getfactoriesForDropDown(
      accountPayable.groupID
    );
    setFactories(factory);
  }

  function changeText(e, rowID, inputType, IDvalue = 0, desc = null) {
    let target = e?.target ? e.target : '';
    let value = target !== '' ? target.value : '';

    const newArr = [...journalData];
    var idx = newArr.findIndex(e => e.rowID == parseInt(rowID));
    const AccountTypeName = newArr[idx].accountTypeName;
    for (let i = 0; i < newArr.length; i++) {
      if (i !== idx && newArr[i].accountTypeName === AccountTypeName) {
        if (inputType === 'credit' && parseInt(newArr[i].debit) !== 0) {
          alert.error('No Credit amounts are allowed for this Account.');
          return;
        }
        else if (inputType === 'debit' && parseInt(newArr[i].credit) !== 0) {
          alert.error('No Debit amounts are allowed for this Account.');
          return;
        }
      }
    }
    if (inputType.includes('descriptionType')) {
      newArr[idx] = { ...newArr[idx], descriptionType: desc, descriptionTypeID: IDvalue };
    } else if (inputType === "description") {
      newArr[idx] = { ...newArr[idx], description: value };
    } else if (inputType === "credit") {

      var reg = new RegExp('^[\.0-9]*$');

      if (reg.test(value) == false) {
        alert.error("Allow Only Numbers")
        return;
      }

      let debitBool = false
      let creditBool = false
      if (parseFloat(value.toString()) > 0) {
        debitBool = true;
        creditBool = false
      }
      if (value.toString().length > 20) {
        alert.error('Allow Only 20 Numbers');
        return;
      }
      newArr[idx] = { ...newArr[idx], credit: (value === "" ? 0 : value) };
    } else {

      var reg = new RegExp('^[\.0-9]*$');
      if (reg.test(value) == false) {
        alert.error("Allow Only Numbers")
        return;
      }

      let debitBool = false
      let creditBool = false
      if (parseFloat(value.toString()) > 0) {
        debitBool = false;
        creditBool = true
      }
      if (value.toString().length > 20) {
        alert.error('Allow Only 20 Numbers');
        return;
      }
      newArr[idx] = { ...newArr[idx], debit: (value === "" ? 0 : value) };
    }
    setJournalData(newArr)
  }

  function GenerateRandomID() {
    const d = new Date();
    let ms = d.valueOf();
    let rendomValue = ((ms + Math.floor(Math.random() * 10000)) - 12) + ((ms - 128) + (ms * 512))
    return rendomValue;
  }

  async function getAccountPayableDetails(invoiceDetailID, referenceNumber, groupID, factoryID) {
    let model = {
      invoiceDetailID: parseInt(invoiceDetailID),
      groupID: parseInt(groupID),
      factoryID: parseInt(factoryID),
      referenceNumber: referenceNumber && referenceNumber.toString().trim() !== "" ? referenceNumber.toString() : null,
    };

    let response = await services.getAccountPayableDetailsByReferenceNumber(model);
    let data = response;
    setTitle("View Account Payable");
    setIsView(true);
    const [desc, remark] = data[0].description.split("Rejecting Remark :-");
    setAccountPayable({
      ...accountPayable,
      groupID: data[0].groupID,
      factoryID: data[0].factoryID,
      transactionTypeID: data[0].transactionTypeID,
      referenceNumber: data[0].referenceNumber,
      description: data[0].description,
      desc: desc,
      remark: remark,
      descriptionTypeID: data[0].descriptionTypeID,
      recipientName: data[0].recipientName,
      transactionMode: data[0].transactionMode,
      voucherType: data[0].voucherTypeID,
      payModeID: data[0].payModeID,
      chequeNumber: data[0].chequeNumber == null ? "" : data[0].chequeNumber,
      preparedBy: data[0].preparedBy,
      updatedBy: data[0].updatedBy,
      checkedBy: data[0].checkedBy,
      isInterEstate: data[0].isInterEstate,
      interEstateID: data[0].interEstateID,
      invoiceNo: data[0].invoiceNo,
      payableReferenceNumber: data[0].payableReferenceNumber,
      supplierID: data[0].supplierID,
      tranLedgerAccountID: data[0].tranLedgerAccountID,
      payableDescription: data[0].payableDescription,
    });
    setStatus(data[0].status);
    setRefNo(data[0].referenceNumber);
    setInvoiceNumber(data[0].payableReferenceNumber);
    handleTransactionDateChange(data[0].transactionDate);
    handleInvoiceDateChange(data[0].invoiceDate);
    setIsInterStatus(data[0].isInterEstate)

    let copyArray = data;
    let tranLedgerAccountID = data[0].tranLedgerAccountID;
    let childHeaderModel = {
      groupID: data[0].groupID,
      factoryID: data[0].factoryID,
      childHeaderID: data[0].childHeaderID
    }

    let accountNameList = await getAccountTypeNames(childHeaderModel);
    let tempArray = [...journalData]
    var filteredArray = copyArray.filter((x) => x.accountTypeName !== tranLedgerAccountID);
    var filteredCreditArray = copyArray.filter((x) => x.accountTypeName === tranLedgerAccountID);
    findCreditAccountTransactionUpdate(filteredCreditArray[0], accountNameList);
    filteredArray.forEach(element => {
      let reuslt = GetAll(element.accountTypeName, accountNameList);
      getAccountDescriptionsNormal(element.accountTypeName);
      const [desc, remark] = element.description.split("Rejecting Remark :-");
      tempArray.push(
        {
          accountTypeName: element.accountTypeName,
          childHeaderName: element.childHeaderName,
          description: element.description,
          desc: desc,
          remark: remark,
          credit: element.credit,
          debit: element.debit,
          ledgerTransactionID: element.ledgerTransactionID,
          rowID: GenerateRandomID(),
          ledgerAccountCode: element.ledgerAccountCode,
          ledgerAccountName: element.ledgerAccountName,
          descriptionTypeID: element.descriptionTypeID,
          selected: reuslt
        }
      )
    });

    function findCreditAccountTransactionUpdate(filteredCreditArray, accountNameList) {
      let reuslt = GetAll(filteredCreditArray.accountTypeName, accountNameList);
      getAccountDescriptionsNormal(filteredCreditArray.accountTypeName);
      let model = {
        accountTypeName: filteredCreditArray.accountTypeName,
        childHeaderName: filteredCreditArray.childHeaderName,
        description: filteredCreditArray.description,
        credit: filteredCreditArray.credit,
        debit: filteredCreditArray.debit,
        ledgerTransactionID: filteredCreditArray.ledgerTransactionID,
        rowID: 0,
        ledgerAccountCode: filteredCreditArray.ledgerAccountCode,
        ledgerAccountName: filteredCreditArray.ledgerAccountName,
        descriptionTypeID: filteredCreditArray.descriptionTypeID,
        tranLedgerAccountID: filteredCreditArray.tranLedgerAccountID,
        selected: reuslt
      }
    } setJournalData(tempArray)
  }

  async function getGroupsForDropdown() {
    const groups = await services.getGroupsForDropdown();
    setGroups(groups);
  }

  async function getTransactionModeList() {
    const transactionModes = await services.getTransactionModeList();
    setTransactionModes(transactionModes);
    return transactionModes;
  }

  async function getVoucherTypeList() {
    const voucherTypes = await services.getVoucherTypeList();
    setVoucherTypes(voucherTypes);
    return voucherTypes;
  }

  function generateDropDownMenu(data) {
    let items = [];
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(
          <MenuItem key={key} value={key}>
            {value}
          </MenuItem>
        );
      }
    }
    return items;
  }

  function handleChangeForm(e) {
    const target = e.target;
    const value = target.value
    setAccountPayable({
      ...accountPayable,
      [e.target.name]: value
    });
  }

  async function transactionModeChange(e) {
    const target = e.target;
    const value = target.value
    var voucherCode = concatenate(accountPayable.voucherType, value);
    trackPromise(getReferenceNumber(voucherCode));
  }

  function handleChangeSupplier(e) {
    const target = e.target;
    const value = target.value;
    setAccountPayable({
      ...accountPayable,
      [e.target.name]: value
    });
  }

  function concatenate(voucherType, transactionMode) {
    const voucherCode = voucherTypes.find(x => x.voucherTypeID === voucherType)
    const transactionCode = transactionModes.find(x => x.payableModeID === transactionMode)
    const concatCode = transactionCode.payableModeCode.concat(voucherCode.voucherTypeCode)
    return concatCode;
  }

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
        <Grid item md={2} xs={12}>
          <PageHeader
            onClick={handleClick}
          />
        </Grid>
      </Grid>
    )
  }

  function generateDropDownMenuForInterEstate(data, selectedValue) {
    selectedValue = selectedValue.toString();
    if (accountPayable.factoryID != 0) {
      let items = [];
      if (data != null) {
        for (const [key, value] of Object.entries(data)) {
          items.push(
            <MenuItem key={key} value={key} disabled={key === selectedValue}>
              {value}
            </MenuItem>
          );
        }
      }
      return items;
    }
  }

  function calDebitTotal() {
    let sum = 0;
    journalData.forEach(element => {
      sum += parseFloat(element.debit);
    });
    return sum.toFixed(2);
  }

  function generateDropownForVoucherList(dataList) {
    let items = [];
    if (dataList != null) {
      voucherTypes.forEach(x => {
        items.push(
          <MenuItem key={x.voucherTypeID} value={x.voucherTypeID}>
            {x.voucherTypeName}
          </MenuItem>
        );
      });
    }
    return items;
  }

  function generateDropownForTransactionModeList(dataList) {
    let items = []
    if (dataList != null) {
      transactionModes.forEach(x => {
        items.push(<MenuItem key={x.payableModeID} value={x.payableModeID}>{x.payableModeName}</MenuItem>)
      });
    }
    return items
  }

  function GetAll(ledgerAccountID, accountTypeNames) {
    const result = accountTypeNames.filter(
      a => a.ledgerAccountID.toString() === ledgerAccountID.toString()
    );
    return result;
  }

  function isInterEstatehandleChange(e) {
    const target = e.target;
    const value =
      target.name === 'isInterEstate' ? target.checked : target.value;
    setAccountPayable({
      ...accountPayable,
      [e.target.name]: value
    });
  }

  return (
    <Fragment>
      <LoadingComponent />
      <Page className={classes.root} title={title}>
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: accountPayable.groupID,
              factoryID: accountPayable.factoryID,
              referenceNumber: referenceNumber,
              recipientName: accountPayable.recipientName,
              description: accountPayable.description,
              descriptionTypeID: accountPayable.descriptionTypeID,
              voucherType: accountPayable.voucherType,
              transactionMode: accountPayable.transactionMode,
              chequeNumber: accountPayable.chequeNumber,
              isActive: accountPayable.isActive,
              isInterEstate: accountPayable.isInterEstate,
              interEstateID: accountPayable.interEstateID,
              invoiceNo: accountPayable.invoiceNo,
              payableReferenceNumber: accountPayable.payableReferenceNumber,
              tranLedgerAccountID: accountPayable.tranLedgerAccountID,
              supplierID: accountPayable.supplierID,
              payableDescription: accountPayable.payableDescription
            }}
            enableReinitialize
          >
            {({ errors, handleBlur, handleSubmit, touched, values }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader title={cardTitle(title)} />
                    <PerfectScrollbar>
                      <Divider />
                      <CardContent>
                        <Grid container spacing={3}>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="groupID">
                              Group *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.groupID && errors.groupID)}
                              fullWidth
                              helperText={touched.groupID && errors.groupID}
                              name="groupID"
                              size='small'
                              onBlur={handleBlur}
                              onChange={(e) => handleChangeForm(e)}
                              value={values.groupID}
                              disabled="true"
                              variant="outlined"
                              id="groupID"
                              InputProps={{
                                readOnly: true,
                              }}
                            >
                              <MenuItem value="0">--Select Group--</MenuItem>
                              {generateDropDownMenu(groups)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="factoryID">
                              Factory *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.factoryID && errors.factoryID)}
                              fullWidth
                              helperText={touched.factoryID && errors.factoryID}
                              name="factoryID"
                              size='small'
                              onBlur={handleBlur}
                              onChange={(e) => handleChangeForm(e)}
                              value={accountPayable.factoryID}
                              variant="outlined"
                              id="factoryID"
                              InputProps={{
                                readOnly: isView || !permissionList.isFactoryFilterEnabled ? true : false,
                              }}
                              disabled={isInterStatus || "true"}
                            >
                              <MenuItem value="0">--Select Factory--</MenuItem>
                              {generateDropDownMenu(factories)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="date" style={{ marginBottom: '-8px' }}>
                              Transaction Date *
                            </InputLabel>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <KeyboardDatePicker
                                fullWidth
                                inputVariant="outlined"
                                format="dd/MM/yyyy"
                                margin="dense"
                                id="date-picker-inline"
                                value={selectedTransactionDate}
                                disabled={isView}
                                InputProps={{
                                  readOnly: isView ? true : false,
                                }}
                                onChange={(e) => {
                                  handleTransactionDateChange(e)
                                }}
                                KeyboardButtonProps={{
                                  'aria-label': 'change date',
                                }}
                                autoOk
                              />
                            </MuiPickersUtilsProvider>
                          </Grid>
                          {Hidden == true ? <Grid item md={3} xs={12}>
                            <InputLabel shrink id="payableReferenceNumber">
                              Reference No *
                            </InputLabel>
                            <TextField
                              fullWidth
                              name="payableReferenceNumber"
                              size='small'
                              onBlur={handleBlur}
                              onChange={(e) => handleChangeForm(e)}
                              value={invoiceNumber}
                              variant="outlined"
                              InputProps={{
                                readOnly: true,
                              }}
                              disabled={isInterStatus || "true"}
                            />
                          </Grid> : null}
                          {Hidden == true ?
                            <Grid item md={3} xs={12}>
                              <InputLabel shrink id="voucherType">
                                Voucher Type *
                              </InputLabel>
                              <TextField select
                                error={Boolean(touched.voucherType && errors.voucherType)}
                                fullWidth
                                helperText={touched.voucherType && errors.voucherType}
                                name="voucherType"
                                size='small'
                                onBlur={handleBlur}
                                onChange={(e) => handleChangeForm(e)}
                                value={accountPayable.voucherType}
                                variant="outlined"
                                id="voucherType"
                                InputProps={{
                                  readOnly: isView ? true : false,
                                }}
                                disabled={isInterStatus}
                              >
                                <MenuItem value="0">--Select Voucher Type--</MenuItem>
                                {generateDropownForVoucherList(voucherTypes)}
                              </TextField>
                            </Grid> : null}

                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="transactionMode">
                              Transaction Mode *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.transactionMode && errors.transactionMode)}
                              fullWidth
                              helperText={touched.transactionMode && errors.transactionMode}
                              name="transactionMode"
                              size='small'
                              onBlur={handleBlur}
                              onChange={(e) => {
                                handleChangeForm(e)
                                trackPromise(transactionModeChange(e))
                              }}
                              value={accountPayable.transactionMode}
                              variant="outlined"
                              id="transactionMode"
                              InputProps={{
                                readOnly: isView ? true : false,
                              }}
                              disabled={isInterStatus || "true"}
                            >
                              <MenuItem value="0">--Select Transaction Mode--</MenuItem>
                              {generateDropownForTransactionModeList(transactionModes)}
                            </TextField>
                          </Grid>

                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="supplierID">
                              Supplier *
                            </InputLabel>
                            <TextField
                              select
                              error={Boolean(
                                touched.supplierID && errors.supplierID
                              )}
                              fullWidth
                              helperText={touched.supplierID && errors.supplierID}
                              name="supplierID"
                              size="small"
                              onBlur={handleBlur}
                              onChange={e => handleChangeSupplier(e)}
                              value={values.supplierID}
                              disabled={accountPayable.transactionMode !== 1 || "true"}
                              InputProps={{
                                readOnly: isView || !permissionList.isFactoryFilterEnabled ? true : false,
                              }}
                              variant="outlined"
                              id="supplierID"
                            >
                              <MenuItem value="0">--Select Supplier--</MenuItem>
                              {generateDropDownMenuWithTwoValues(suppliers)}
                            </TextField>
                          </Grid>

                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="invoiceNo">
                              Invoice No *
                            </InputLabel>
                            <TextField
                              error={Boolean(touched.invoiceNo && errors.invoiceNo)}
                              fullWidth
                              helperText={touched.invoiceNo && errors.invoiceNo}
                              name="invoiceNo"
                              size="small"
                              disabled="true"
                              onBlur={handleBlur}
                              onChange={e => handleChangeForm(e)}
                              value={accountPayable.invoiceNo}
                              InputProps={{
                                readOnly: isView || !permissionList.isFactoryFilterEnabled ? true : false,
                              }}
                              variant="outlined"
                            />
                          </Grid>

                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="date" style={{ marginBottom: '-8px' }}>
                              Invoice Date *
                            </InputLabel>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <KeyboardDatePicker
                                fullWidth
                                inputVariant="outlined"
                                format="dd/MM/yyyy"
                                margin="dense"
                                id="date-picker-inline"
                                value={selectedInvoicenDate}
                                disabled={isView}
                                InputProps={{
                                  readOnly: isView ? true : false,
                                }}
                                onChange={(e) => {
                                  handleInvoiceDateChange(e)
                                }}
                                KeyboardButtonProps={{
                                  'aria-label': 'change date',
                                }}
                                autoOk
                              />
                            </MuiPickersUtilsProvider>
                          </Grid>

                          {isView ?
                            <Grid item md={3} xs={12}>
                              <InputLabel shrink id="referenceNumber">
                                Voucher Code *
                              </InputLabel>
                              <TextField
                                error={Boolean(touched.referenceNumber && errors.referenceNumber)}
                                fullWidth
                                helperText={touched.referenceNumber && errors.referenceNumber}
                                name="referenceNumber"
                                size='small'
                                onBlur={handleBlur}
                                onChange={(e) => handleChangeForm(e)}
                                value={refNo}
                                variant="outlined"
                                InputProps={{
                                  readOnly: true,
                                }}
                                disabled={isInterStatus || "true"}
                              />
                            </Grid>
                            : null}

                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="tranLedgerAccountID">
                              Ledger Account *
                            </InputLabel>
                            <TextField
                              select
                              error={Boolean(
                                touched.tranLedgerAccountID &&
                                errors.tranLedgerAccountID
                              )}
                              fullWidth
                              helperText={
                                touched.tranLedgerAccountID &&
                                errors.tranLedgerAccountID
                              }
                              name="tranLedgerAccountID"
                              size="small"
                              onBlur={handleBlur}
                              onChange={e => {
                                handleChangeForm(e);
                              }}
                              value={accountPayable.tranLedgerAccountID}
                              variant="outlined"
                              id="tranLedgerAccountID"
                              disabled={isInterStatus || isView}
                              InputProps={{
                                readOnly: isView ? true : false
                              }}
                            >
                              <MenuItem value="0">
                                --Select Ledger Account--
                              </MenuItem>
                              {generateDropDownMenu(
                                tranLedgerList
                              )}
                            </TextField>
                          </Grid>

                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="payableDescription">
                              Description
                            </InputLabel>
                            <TextField
                              fullWidth
                              placeholder="--Enter Description --"
                              name="payableDescription"
                              size="small"
                              onBlur={handleBlur}
                              onChange={e => handleChangeForm(e)}
                              value={accountPayable.payableDescription}
                              disabled={isInterStatus}
                              InputProps={{
                                readOnly: isView || !permissionList.isFactoryFilterEnabled ? true : false,
                              }}
                              variant="outlined"
                            />
                          </Grid>
                        </Grid>

                      </CardContent>
                      <CardContent height="auto">
                        <Box style={{ border: "1px solid gray" }}>
                          <Table>
                            <TableHead>
                              <TableRow>
                                <TableCell>Child Header *</TableCell>
                                <TableCell>Account Name *</TableCell>
                                <TableCell>Description</TableCell>
                                <TableCell>Description Category</TableCell>
                                <TableCell>Amount *</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {journalData.map((object) => {
                                let ID = object.rowID;
                                return (
                                  <TableRow key={ID}>
                                    <TableCell className="table-cell">
                                      <TextField
                                        variant="outlined"
                                        size="small"
                                        name={ID}
                                        onBlur={handleBlur}
                                        disabled={true}
                                        value={object.childHeaderName}
                                        fullWidth
                                      />
                                    </TableCell>
                                    <TableCell className="table-cell">
                                      <TextField
                                        variant="outlined"
                                        size="small"
                                        name={ID}
                                        onBlur={handleBlur}
                                        disabled={true}
                                        value={object.ledgerAccountName}
                                        fullWidth
                                      />
                                    </TableCell>
                                    <TableCell className="table-cell">
                                      <TextField
                                        variant="outlined"
                                        size="small"
                                        placeholder="--Enter Description--"
                                        name={ID}
                                        onBlur={handleBlur}
                                        onChange={(e) => changeText(e, ID, "description")}
                                        disabled={isView || isInterStatus}
                                        value={object.desc}
                                        fullWidth
                                      />
                                    </TableCell>
                                    <TableCell className="table-cell">
                                      {isView ? (
                                        <TextField
                                          select
                                          fullWidth
                                          name="descriptionType"
                                          size="small"
                                          onBlur={handleBlur}
                                          onChange={(e) => handleChangeForm(e)}
                                          value={object.descriptionTypeID}
                                          disabled={isView}
                                          variant="outlined"
                                        >
                                          <MenuItem value="0">--Select Description Type--</MenuItem>
                                          {generateDropDownMenu(accountDescriptionsType)}
                                        </TextField>
                                      ) : (
                                        <Autocomplete
                                          id={ID.toString()}
                                          key={object.descriptionTypeID}
                                          options={accountDescriptions?.[ID] ?? []}
                                          size="small"
                                          disabled={!(accountDescriptions?.[ID] && accountDescriptions[ID].length > 0)}
                                          freeSolo={!accountDescriptions?.[ID]}
                                          getOptionLabel={(option) =>
                                            typeof option === "string" ? option : option.accountDescription
                                          }
                                          onChange={(e, value) => {
                                            if (value && value.accountDescriptionTypeID !== undefined) {
                                              changeText(e, ID, "descriptionType", value.accountDescriptionTypeID, value.accountDescription);
                                            }
                                          }}
                                          clearOnBlur
                                          disableClearable={!accountDescriptions?.[ID]}
                                          value={
                                            accountDescriptions?.[ID]?.find(
                                              (desc) => desc.accountDescriptionTypeID === object.descriptionTypeID
                                            ) || null
                                          }
                                          renderInput={(params) => (
                                            <TextField {...params} fullWidth variant="outlined" placeholder="--Select Description Type--" />
                                          )}
                                        />
                                      )}
                                    </TableCell>
                                    <TableCell className="table-cell">
                                      <TextField
                                        variant="outlined"
                                        size="small"
                                        name={ID}
                                        onBlur={handleBlur}
                                        onChange={(e) => changeText(e, ID, "debit")}
                                        value={object.debit}
                                        fullWidth
                                        disabled={isInterStatus || isView}
                                      />
                                    </TableCell>
                                  </TableRow>
                                );
                              })}
                            </TableBody>
                          </Table>
                        </Box>
                        {status == 3 ?
                          <>
                            <Grid container spacing={3} style={{ marginTop: "0.5rem" }}>
                              <Grid item md={6} xs={12}>
                                <InputLabel shrink id="rejectRemark">
                                  Rejecting Remark *
                                </InputLabel>
                                <TextField
                                  fullWidth
                                  size='small'
                                  name="rejectRemark"
                                  onBlur={handleBlur}
                                  readOnly={isView}
                                  value={accountPayable.remark}
                                  variant="outlined"
                                  id="rejectRemark"
                                  multiline
                                  rows={3}
                                />
                              </Grid>
                            </Grid>
                          </>
                          : null}
                      </CardContent>
                      <CardContent>
                        <Box border={1} borderColor="#626964" padding="1rem">
                          <Grid container md={12} spacing={2}>
                            <Grid container item md={12} alignItems="center">
                              <Grid item md={5} xs={12}>
                                <InputLabel><b>Total Amount (Rs)</b> {": "}
                                  <CountUp decimals={2} separator=',' end={calDebitTotal()} duration={0.1} />
                                </InputLabel>
                              </Grid>
                              <Grid item md={5} xs={12} style={{ textAlign: 'right' }}>
                                <InputLabel><b>Prepared By</b> {accountPayable.preparedBy == null || accountPayable.preparedBy === "" ? ": _" : ": " + accountPayable.preparedBy}</InputLabel>
                              </Grid>
                            </Grid>
                            <Grid container item md={12} alignItems="center" style={{ marginTop: '1rem' }}>
                              <Grid item md={5} xs={12}>
                                <InputLabel><b>Updated By</b> {accountPayable.updatedBy == null || accountPayable.updatedBy === "" ? ": _" : ": " + accountPayable.updatedBy}</InputLabel>
                              </Grid>
                              <Grid item md={5} xs={12} style={{ textAlign: 'right' }}>
                                <InputLabel><b>Checked By</b> {accountPayable.checkedBy == null || accountPayable.checkedBy === "" ? ": _" : ": " + accountPayable.checkedBy}</InputLabel>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Box>
                      </CardContent>
                    </PerfectScrollbar>
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Page>
    </Fragment>
  );
}
